import shop from '../../api/payOrder';
import { sendSuccessNotice, sendErrorNotice, getCurrentTime } from '@/commons/utils';
import Vue from 'vue';

// initial state
const state = {
    loading: false,
    selectedItem: {},
    all: [],
    total: 0
};

// getters
const getters = {};

// actions
const actions = {
    getPayOrderList({ commit }, param) {
        commit('setLoading', {loading: true});
        shop.getPayOrderList(data => {
            commit('setPayOrderList', data);
            commit('setLoading', {loading: false});
        }, Vue.http, param, this.state.authentication.token);
    },
    getPayOrderDetail({ commit }, customerId) {
        commit('setLoading', {loading: true});
        shop.getPayOrderDetail(data => {
            commit('setPayOrderDetail', data);
            commit('setLoading', {loading: false});
        }, Vue.http, customerId, this.state.authentication.token);
    },
    updatePayOrder({ commit, dispatch }, {package_ids, otherFee, uid, param}) {
        shop.updatePayOrder(data => {
            dispatch('getPayOrderList', param);
            dispatch('paymentHistory/getPaymentHistoryList', param, {root: true});
            sendSuccessNotice('Thanh toán thành công.')
        }, Vue.http, {package_ids, otherFee, uid}, this.state.authentication.token);
    },
};

// mutations
const mutations = {
    setPayOrderList(state, res) {
        state.all = res.data;
        state.total = res.total;
    },
    setPayOrderDetail(state, item) {
        state.selectedItem = item.data;
    },
    setLoading(state, { loading }) {
        _.debounce(function () { state.loading = loading; }, 400, {
            'leading': false,
            'trailing': true
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
